import React from "react";
import { Component } from "react";
import { Api } from "../../utils/api";
import { Field, Formik } from "formik";
import { MaterialSelectFormik } from "../components/select-field.component";
import Grid from "@material-ui/core/Grid";
import { date, number, object } from "yup";
import { DateTimePicker } from "./datetime-picker.component";
import moment from "moment";
import AlertDialog from "../../components/alert.component";

class BookCalls extends Component {
  constructor() {
    super();
    this.api = new Api();
    this.showAlert = this.showAlert.bind(this);
    this.closeAlert = this.closeAlert.bind(this);
  }

  state = {
    showAlert: false,
    alertTitle: "",
    alertMessage: "",
  };

  componentDidMount() {
    this.showAlert();
    this.closeAlert();
  }

  showAlert(title, message) {
    this.setState({ showAlert: true });
    this.setState({ alertTitle: title });
    this.setState({ alertMessage: message });
  }

  closeAlert() {
    this.setState({ showAlert: false });
  }

  render() {
    const today = moment().format("YYYY-MM-DD HH:mm");

    const validationSchema = object().shape({
      request_id: number().required(),
      social_worker_id: number().required(),
      call_motive_id: number().required("Obrigatório"),
      book_to: date()
        .required("A data não pode ser anterior ao dia de hoje")
        .min(today),
    });

    const url = window.location.pathname;
    const req_id = url.substring(url.lastIndexOf("/") + 1);

    const optionsToSelect = (options) => {
      return options.map((option) => ({
        value: option.id,
        label: option.call_motive,
      }));
    };

    const callMotivesOptionsPromise = () => {
      const api = new Api();
      return api
        .get("/call_motives")
        .then((res) => res.data)
        .then(optionsToSelect);
    };

    const newBookCallPromisse = (data) => {
      const api = new Api();
      return api
        .post(`/bookcalls`, data)
        .then((res) => {
          console.log(res.json);
          //método para receber informação dos agendamentos (user_requests.view)
          this.props.getDateFromLastBookcall();
          this.showAlert("Sucesso", "Agendado com sucesso!");
        })
        .catch((err) => {
          console.log(err);
          this.showAlert("Erro", "Ocorreu um erro ao gravar!");
        });
    };

    return (
      <div class="w-25 mx-auto">
        <h1 class="h5 text-center mb-2 pt-4 text-primary">Agendar Contacto</h1>
        <Grid item md={12}>
          <Formik
            initialValues={{
              request_id: req_id,
              social_worker_id: localStorage.id,
              call_motive_id: "",
              book_to: today,
            }}
            validationSchema={validationSchema}
            validateOnChange={true}
            validateOnBlur={true}
            onSubmit={(values, { setSubmitting }) => {
              setTimeout(() => {
                values.book_to = moment(values.book_to).format(
                  "YYYY-MM-DD HH:mm"
                );
                console.log(JSON.stringify(values, null, 2));
                newBookCallPromisse(values);
                setSubmitting(false);
              }, 400);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
              setFieldTouched,
              handleInputChange,
            }) => (
              <form onSubmit={handleSubmit}>
                <div class="form-group">
                  <div // ID DO PEDIDO
                    type="hidden"
                    name="request_id"
                  />
                  <div // ID DA ASSISTENTE SOCIAL
                    type="hidden"
                    name="social_worker_id"
                  />

                  <div>
                    <Field // MOTIVO DA O AGENDAMENTO
                      class="form-control mb-1 p-2"
                      search
                      name="call_motive_id"
                      label="Motivo da chamada"
                      optionsFetcher={callMotivesOptionsPromise}
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      value={values.call_motive_id}
                      component={MaterialSelectFormik}
                    />
                  </div>
                  <div>
                    <Field
                      name="book_to"
                      label="Data de agendamento"
                      variant="outlined"
                      margin="normal"
                      required
                      onChange={setFieldValue}
                      component={DateTimePicker}
                      value={values.book_to}
                      fullWidth
                    />
                  </div>
                  <div class="text-center">
                    <button
                      type="submit"
                      class="btn btn-primary"
                      disabled={isSubmitting}
                    >
                      Agendar
                    </button>
                  </div>
                </div>
              </form>
            )}
          </Formik>
        </Grid>
        <AlertDialog
          open={this.state.showAlert}
          handleClose={this.closeAlert}
          title={this.state.alertTitle}
          message={this.state.alertMessage}
        ></AlertDialog>
      </div>
    );
  }
}

export default BookCalls;
